export default "__VITE_ASSET__B4BioSsd__"